import { Component, inject, Injectable } from '@angular/core';
import { CodeSnippet } from './code-snippet.interface';
import { Observable, Subject, lastValueFrom } from 'rxjs';
import { ScriptMode } from '../enums';

import Mustache from 'mustache';
import { DevExtremeDataSourceAdapter } from '@tools';
import { Config } from '@config';
import { UrlEnhancerService } from '@url';
import { States, StateService } from '@state';

@Component({
    selector: 'process-alarms',
    template: `
        <clx-popover
            #editorwindow
            *ngIf="isDialogOpen"
            [minWidth]="400"
            [maxWidth]="800"
            class="popup"
            height="auto"
            width="auto"
            title="Process Alarms"
            i18n-title="@@script-editor.snippet.process-alarms.popup.title"
            [closeOnOutsideClick]="false"
            [(visible)]="isDialogOpen"
            (visibleChange)="visibilityChanged($event)"
        >
            <clx-row has="full-size-columns big-layout">
                <clx-label>Variable name</clx-label>
                <clx-item>
                    <clx-input
                        name="varname"
                        #varname
                        value="alarm"
                    >
                        <clx-validation type="required"></clx-validation>
                    </clx-input>

                </clx-item>
            </clx-row>
            <clx-row type="buttons">
                <clx-button
                    i18n="@@script-editor.snippets.add-alarm-loop.button"
                    (click)="addAlarmLoop(varname.value)"
                >Add</clx-button>
            </clx-row>
        </clx-popover>
    
    `,
    standalone: false
})
export class ProcessAlarmsSnippet implements CodeSnippet {

    #dxDataAdapter: DevExtremeDataSourceAdapter = inject(DevExtremeDataSourceAdapter);

    #config: Config = inject(Config);

    #urlEnhancer: UrlEnhancerService = inject(UrlEnhancerService);

    #stateService: StateService = inject(StateService);


    visibilityChanged(value) {
        if (value === false) {
            this.subject.next(null);
            this.isDialogOpen = false;
            this.subject.complete();
        }
    }

    part = true;

    text: string = $localize`:@@script-editor.snippet.process-alarms:Process Alarms`;

    static category: string = 'climatix';

    isDialogOpen: boolean = false;

    data: any;

    selectedRootCauses: any;

    subject: Subject<any> = new Subject()

    observable: Observable<any> = this.subject.asObservable();

    addAlarmLoop(varname) {
        this.subject.next({ varname })
        this.subject.complete()
    }

    static filter = [
        ScriptMode.alarmAction
    ];

    async insert(): Promise<string> {
        this.subject = new Subject()
        this.observable = this.subject.asObservable();
        this.isDialogOpen = true;
        const value = await lastValueFrom(this.observable);
        this.isDialogOpen = false;

        return Mustache.render(`
    -- iterate alarms
    for {{varname}} in alarms() do

�        -- add your code here. try 'Process specific Alarm' snippet...�

    end
        `, value);
    }

}